module.exports = __webpack_public_path__ + "img/Broken Bail.7e6ea835.png";